import dayReviewChannel from "../../../../javascript/channels/day_reviews/day_review_channel";

export default class extends Controller {

  connect() {
    App.Helpers.listenToCustomEvent(document, "day-reviews--calendar-link-update", this.replaceContentMaybe.bind(this))
    App.Helpers.listenToCustomEvent(document, "day-reviews--calendar-disconnect", this.renderDisconnectedMaybe.bind(this))
    this.channel = dayReviewChannel.init({ userID: this.userID, date: this.date })
  }

  disconnect() {
    this.channel.unsubscribe()
  }

  replaceContentMaybe(event) {
    const { html, userID, date } = event.detail
    if (this.matchingDetails(userID, date)) {
      App.Helpers.replaceElement(this.element, html)
    }
  }

  renderDisconnectedMaybe(event) {
    const { userID, date } = event.detail
    if (this.matchingDetails(userID, date)) {
      this.disconnected = true
    }
  }

  matchingDetails(userID, date) {
    return userID === this.userID && date === this.date
  }

  get userID() {
    return this.data.get("user-id")
  }

  get date() {
    return this.data.get("date")
  }

  set disconnected(val) {
    if (val) {
      this.element.innerHTML = App.spinner()
    }
  }
}



// WEBPACK FOOTER //
// ./app/components/day_reviews/assets/javascript/day-reviews-calendar-slide-out-opener-container-controller.js